import React from 'react';
import { AppBar, Toolbar, Box, Button, IconButton, Drawer, List, ListItemButton, ListItemText, Container, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { brand, siteLogoUrl } from '../theme';

const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Concierge', to: '/concierge' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export default function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = React.useState(false);
  const { pathname } = useLocation();

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'rgba(255,255,255,0.78)',
        color: brand.navy,
        borderBottom: `1px solid ${brand.border}`,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: 76, gap: 2 }}>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: 'inherit',
              flex: 1,
            }}
          >
            <Box
              component="img"
              src={siteLogoUrl}
              alt="G&R Nexus"
              sx={{
                height: { xs: 36, sm: 40 },
                width: 'auto',
                maxWidth: { xs: 200, sm: 260 },
                objectFit: 'contain',
              }}
            />
          </Box>

          {!isMobile && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {NAV.map((item) => {
                const active = pathname === item.to;
                return (
                  <Button
                    key={item.to}
                    component={RouterLink}
                    to={item.to}
                    sx={{
                      color: active ? brand.blue : brand.navy,
                      fontWeight: 600,
                      px: 2,
                      '&:hover': { bgcolor: 'rgba(30,91,255,0.06)', color: brand.blue },
                    }}
                  >
                    {item.label}
                  </Button>
                );
              })}
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/contact"
                sx={{ ml: 1 }}
              >
                Book a demo
              </Button>
            </Box>
          )}

          {isMobile && (
            <IconButton
              edge="end"
              onClick={() => setOpen(true)}
              sx={{ color: brand.navy }}
              aria-label="Open menu"
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </Container>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 280, p: 2 }} role="presentation">
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton onClick={() => setOpen(false)} aria-label="Close menu">
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {NAV.map((item) => (
              <ListItemButton
                key={item.to}
                component={RouterLink}
                to={item.to}
                onClick={() => setOpen(false)}
                selected={pathname === item.to}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
              </ListItemButton>
            ))}
            <Box sx={{ mt: 2, px: 2 }}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/contact"
                onClick={() => setOpen(false)}
              >
                Book a demo
              </Button>
            </Box>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}
